export default __webpack_public_path__ + "static/media/img-4.05a33199.jpg";